<template lang="pug">
.mainbody
    //- +++++++++++++++++++++++++++++++++++++++++++
    //- Sidebar Default
    //- +++++++++++++++++++++++++++++++++++++++++++
    BaseSidebar
        .text-xs hello

    main.mainbox
        //- +++++++++++++++++++++++++++++++++++++++++++
        //- Navbar
        //- +++++++++++++++++++++++++++++++++++++++++++
        .w-full.sticky.top-0.left-0.z-5

            //- custom navbar
            slot(v-if="$slots.navbar" name="navbar")

            //- default navbar
            BaseNavbar(
                v-if="!$slots.navbar && navbar"
                :title="title"
            )
                template(#leftbar)
                    slot(name="leftbar")

            BaseNavbar(
                v-else-if="!$slots.sidebar && navbar && !$slots.navbar"
                :title="title"
            )
                template(#right)
                    slot(name="right")



        //- +++++++++++++++++++++++++++++++++++++++++++
        //- MainBox
        //- +++++++++++++++++++++++++++++++++++++++++++
        .fullpage.overflow-hidden.w-full.flex.sticky.top-0.left-0.z-1(
            ref="fullpage"
        )
            .flex.border-r.sticky.overflow-x-hidden.flex-col.top-0.left-0.overflow-y-auto(
                ref="fullpageLeftBar"
                v-if="$slots.leftbar && storeCT.leftBarValue !== 0"
            )

                .flex.flex-grow.h-full.flex-col(
                    :class="{'max-w-14 overflow-x-hidden w-14': storeCT.leftBarValue === 1}"
                    :style="{'width': storeCT.leftBarValue === 2 ? storeCT.leftBarWidthValue : 'auto'}"
                )
                    .flex-1
                        slot(name="leftbar")
                    .flex.px-2
                        .flex.flex-1.items-center.py-2
                            UButton.font-normal.cursor-pointer.transition-all.duration-300(
                                :class="{'justify-start': storeCT.leftBarValue === 2, 'justify-center': storeCT.leftBarValue === 1}"
                                block
                                size="sm"
                                color="secondary"
                                variant="ghost"
                                :icon="storeCT.leftBarValue === 2 ? 'lucide:arrow-left-from-line' : storeCT.leftBarValue === 1 ? 'lucide:arrow-left-from-line' : 'lucide:arrow-right-from-line'"
                                :label="storeCT.leftBarValue === 2 ? 'Collapse' : ''"
                                @click="storeCT.leftBar = storeCT.leftBar === 2 ? 1 : storeCT.leftBar === 1 ? 0 : 2"
                            )

            .sticky.overflow-x-hidden.flex.flex-1.top-0.left-0.overflow-y-auto
                .flex.flex-1.flex-col.overflow-x-auto
                    slot(name="default")

            .flex.border-l.sticky.overflow-x-hidden.flex-col.top-0.left-0.overflow-y-auto(
                ref="fullpageRightBar"
                v-if="$slots.rightbar && storeCT.rightBarValue !== 0"
            )
                .flex.flex-grow.h-full.flex-col(
                    :class="{'max-w-14 overflow-hidden w-14': storeCT.rightBarValue === 1}"
                    :style="{'width': storeCT.rightBarValue === 2 ? storeCT.rightBarWidthValue : 'auto'}"
                )
                    .flex-1
                        slot(name="rightbar")
                    .flex.px-2
                        .flex.flex-1.items-center.py-2
                            UButton.font-normal.cursor-pointer.transition-all.duration-300(
                                :class="{'justify-end': storeCT.rightBarValue === 2, 'justify-center': storeCT.rightBarValue === 1}"
                                block
                                size="sm"
                                color="secondary"
                                variant="ghost"
                                :icon="storeCT.rightBarValue === 2 ? 'lucide:arrow-right-from-line' : storeCT.rightBarValue === 1 ? 'lucide:arrow-right-from-line' : 'lucide:arrow-right-from-line'"
                                :label="storeCT.rightBarValue === 2 ? 'Collapse' : ''"
                                @click="storeCT.rightBar = storeCT.rightBar === 2 ? 1 : storeCT.rightBar === 1 ? 0 : 2"
                            )


        //- ClientOnly
            UModal(
                :close="false"
                :dismissible="false"
                v-model:open="ceklogin"
                title="Session Expired"
                description="Your session has expired. Please login again."
            )
                template(#body)
                    UButton(
                        block
                        size="lg"
                        color="primary"
                        label="Logout"
                        to="/logout"
                    )
</template>
<script setup lang="ts">
import { useTemplateStore } from '../stores/templateStore'
import { useWindowSize } from '@vueuse/core'
const { width, height } = useWindowSize()
defineProps<{
    title?: string
    navbar?: boolean
}>()
const auth = useState('auth')
const ceklogin = ref(true)
const storeCT = useTemplateStore()
const fullpage = ref<HTMLElement | null>(null)
const fullpageLeftBar = ref<HTMLElement | null>(null)
const fullpageRightBar = ref<HTMLElement | null>(null)
const Reposition = () => {
    if (fullpage && fullpage.value) {
        const rect = computed(() => fullpage.value?.getBoundingClientRect().top)
        fullpage.value!.style.height = `calc(100dvh - ${rect.value}px)`
        fullpage.value!.style.overflowY = `auto`
    }
    if (fullpageLeftBar && fullpageLeftBar.value) {
        const rect2 = computed(() => fullpageLeftBar.value?.getBoundingClientRect().top)
        fullpageLeftBar.value!.style.height = `calc(100dvh - ${rect2.value}px)`
    }
    if (fullpageRightBar && fullpageRightBar.value) {
        const rect3 = computed(() => fullpageRightBar.value?.getBoundingClientRect().top)
        fullpageRightBar.value!.style.height = `calc(100dvh - ${rect3.value}px)`
    }
}
onMounted(() => {
    Reposition()
    if (auth.value?.id) {
        ceklogin.value = false
    } else {
        ceklogin.value = true
    }
})

watch(width, () => {
    Reposition()
})
watch(height, () => {
    Reposition()
})

const slots = useSlots()

onBeforeMount(() => {
    if (slots.rightbar) {
        storeCT.rightbarAvailable = true
    } else {
        storeCT.rightbarAvailable = false
    }
    if (slots.leftbar) {
        storeCT.leftbarAvailable = true
    } else {
        storeCT.leftbarAvailable = false
    }
})

onBeforeRouteLeave(() => {
    if (slots.rightbar) {
        storeCT.rightbarAvailable = true
    } else {
        storeCT.rightbarAvailable = false
    }
    if (slots.leftbar) {
        storeCT.leftbarAvailable = true
    } else {
        storeCT.leftbarAvailable = false
    }
})
</script>
